import { render, staticRenderFns } from "./AutoRequisition.vue?vue&type=template&id=700d46fe&scoped=true"
import script from "./AutoRequisition.vue?vue&type=script&lang=js"
export * from "./AutoRequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d46fe",
  null
  
)

export default component.exports